import React, { useEffect, useRef, useState } from "react";

import {
    FaBolt,
    FaCar,
    FaCut,
    FaLaptopCode,
    FaTools,
    FaUtensils,
    FaCheckCircle,
    FaArrowRight,
    FaClock,
    FaGraduationCap,
    
} from "react-icons/fa";

import electricalImage from "./images/courses/electrical.jpg";
import computerScienceImage from "./images/kard3.jpg";
import fashionImage from "./images/taloring.jpg";
import pastryCateringImage from "./images/kard1.jpg";

// import carpentryImage from "./images/courses/carpentry.jpg";
// import cateringImage from "./images/courses/catering.jpg";

const courses = [
    {
        id: "01",
        title: "Electrical Installation",
        shortTitle: "Electrical",
        icon: <FaBolt />,
        image: electricalImage,
        duration: "6 Months",
        level: "Professional Skills",
        description:
            "Develop practical skills in electrical installation, wiring, maintenance, safety procedures, troubleshooting, and basic electrical systems for residential and commercial applications.",
        skills: [
            "Electrical Wiring",
            "Installation",
            "Maintenance",
            "Safety Practices",
        ],
    },
{
    id: "02",
    title: "Computer Science & Information Technology",
    shortTitle: "Computer Science",
    icon: <FaLaptopCode />,
    image: computerScienceImage,
    duration: "9 Months",
    level: "Technical Training",
    description:
        "Build practical computer science and information technology skills through hands-on training in programming, computer hardware, software development, databases, networking, and modern digital technologies.",
    skills: [
        "Programming & Coding",
        "Computer Hardware",
        "Database Management",
        "Networking & IT",
    ],
},
    {
        id: "03",
        title: "Tailoring",
        shortTitle: "Fashion",
        icon: <FaCut />,
        image: fashionImage,
        duration: "6 Months",
        level: "Creative Skills",
        description:
            "Build practical skills in garment construction, measurements, sewing, pattern development, clothing design, finishing techniques, and fashion entrepreneurship.",
        skills: [
            "Tailoring",
            "Pattern Making",
            "Garment Design",
            "Sewing",
        ],
    },
{
    id: "04",
    title: "Pastry & Catering",
    shortTitle: "Catering",
    icon: <FaUtensils />,
    image: pastryCateringImage,
    duration: "6 Months",
    level: "Technical Training",
    description:
        "Develop practical skills in pastry preparation, baking, food presentation, catering services, kitchen operations, and professional food service for events and hospitality settings.",
    skills: [
        "Pastry & Baking",
        "Food Preparation",
        "Catering Services",
        "Kitchen Operations",
    ],
},
    // {
    //     id: "05",
    //     title: "Carpentry & Woodwork",
    //     shortTitle: "Woodwork",
    //     icon: <FaTools />,
    //     image: carpentryImage,
    //     duration: "6 Months",
    //     level: "Technical Skills",
    //     description:
    //         "Learn professional woodworking techniques including measuring, cutting, joining, furniture construction, finishing, workshop safety, and practical project development.",
    //     skills: [
    //         "Furniture Making",
    //         "Woodworking",
    //         "Measurements",
    //         "Finishing",
    //     ],
    // },
    // {
    //     id: "06",
    //     title: "Catering & Hospitality",
    //     shortTitle: "Hospitality",
    //     icon: <FaUtensils />,
    //     image: cateringImage,
    //     duration: "6 Months",
    //     level: "Service Skills",
    //     description:
    //         "Develop practical skills in food preparation, cooking, baking, hospitality service, kitchen management, hygiene, presentation, and small-business opportunities.",
    //     skills: [
    //         "Food Preparation",
    //         "Cooking",
    //         "Baking",
    //         "Hospitality",
    //     ],
    // },
];

const CoursesPage = () => {
    const sectionRef = useRef(null);
    const [visibleCards, setVisibleCards] = useState([]);

    useEffect(() => {
        const section = sectionRef.current;

        if (!section) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const elements =
                            entry.target.querySelectorAll(".course-card");

                        elements.forEach((element, index) => {
                            setTimeout(() => {
                                const courseId =
                                    element.getAttribute("data-course-id");

                                setVisibleCards((previous) =>
                                    previous.includes(courseId)
                                        ? previous
                                        : [...previous, courseId]
                                );
                            }, index * 120);
                        });

                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.12,
            }
        );

        observer.observe(section);

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <section
                ref={sectionRef}
                className="vocational-courses-section"
            >
                <div className="courses-background-circle circle-one" />
                <div className="courses-background-circle circle-two" />
                <div className="courses-background-grid" />

                <div className="courses-container">
                    {/* HEADER */}
                    <div className="courses-header">
                        <div className="courses-eyebrow">
                            <span className="eyebrow-line" />
                            <span>VOCATIONAL TRAINING</span>
                            <span className="eyebrow-line" />
                        </div>

                        <h1>
                            Learn a Skill.
                            <span> Build a Career.</span>
                        </h1>

                        <p>
                            Explore practical vocational courses designed to
                            equip students with technical skills, professional
                            confidence, creativity, and the knowledge needed
                            for employment, entrepreneurship, and productive
                            careers.
                        </p>

                        <div className="header-accent">
                            <span />
                            <span />
                            <span />
                        </div>
                    </div>

                    {/* COURSE GRID */}
                    <div className="courses-grid">
                        {courses.map((course) => (
                            <article
                                key={course.id}
                                data-course-id={course.id}
                                className={`course-card ${
                                    visibleCards.includes(course.id)
                                        ? "visible"
                                        : ""
                                }`}
                            >
                                {/* IMAGE */}
                                <div className="course-image-wrapper">
                                    <img
                                        src={course.image}
                                        alt={course.title}
                                    />

                                    <div className="course-image-overlay" />

                                    <div className="course-image-top">
                                        <span className="course-number">
                                            COURSE {course.id}
                                        </span>

                                        <span className="course-category">
                                            {course.shortTitle}
                                        </span>
                                    </div>
                                </div>

                                {/* FLOATING ICON
                                    This is deliberately OUTSIDE
                                    course-content so it stays above
                                    the white description section.
                                */}
                                <div className="course-icon">
                                    {course.icon}
                                </div>

                                {/* WHITE CONTENT */}
                                <div className="course-content">
                                    <h2 className="course-title">
                                        {course.title}
                                    </h2>

                                    <div className="course-meta">
                                        <span className="course-level">
                                            <FaGraduationCap />
                                            {course.level}
                                        </span>

                                        <span className="course-duration">
                                            <FaClock />
                                            {course.duration}
                                        </span>
                                    </div>

                                    <p className="course-description">
                                        {course.description}
                                    </p>

                                    <div className="skills-heading">
                                        <span />
                                        <strong>KEY SKILLS</strong>
                                    </div>

                                    <div className="course-skills">
                                        {course.skills.map(
                                            (skill, index) => (
                                                <div
                                                    className="course-skill"
                                                    key={`${course.id}-${index}`}
                                                >
                                                    <FaCheckCircle />
                                                    <span>{skill}</span>
                                                </div>
                                            )
                                        )}
                                    </div>

                                    <div className="course-footer">
                                        <span className="course-footer-label">
                                            PRACTICAL TRAINING
                                        </span>

                                        <span className="course-footer-arrow">
                                            <FaArrowRight />
                                        </span>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>

                    {/* BOTTOM CALLOUT */}
                    <div className="courses-callout">
                        <div className="callout-left">
                            <div className="callout-symbol">
                                <FaTools />
                            </div>

                            <div>
                                <div className="callout-small">
                                    SKILLS • TRAINING • OPPORTUNITY
                                </div>

                                <h3>
                                    Turn Practical Skills Into Your Future.
                                </h3>

                                <p>
                                    Learn practical skills today and prepare
                                    yourself for meaningful work,
                                    entrepreneurship, and lifelong
                                    professional development.
                                </p>
                            </div>
                        </div>

                        <div className="callout-arrow">
                            <FaArrowRight />
                        </div>
                    </div>
                </div>
            </section>

            <style>{`
                * {
                    box-sizing: border-box;
                }

                .vocational-courses-section {
                    position: relative;
                    width: 100%;
                    overflow: hidden;

                    padding: 100px 25px 110px;

                    background:
                        linear-gradient(
                            135deg,
                            #ffffff 0%,
                            #f7fbf8 48%,
                            #eef8f1 100%
                        );

                    font-family:
                        "Poppins",
                        "Segoe UI",
                        Arial,
                        sans-serif;
                }

                .courses-container {
                    position: relative;
                    z-index: 5;

                    width: 100%;
                    max-width: 1320px;

                    margin: 0 auto;
                }

                /* =========================
                   BACKGROUND DECORATIONS
                ========================= */

                .courses-background-circle {
                    position: absolute;
                    border-radius: 50%;
                    pointer-events: none;
                    z-index: 0;
                }

                .circle-one {
                    width: 430px;
                    height: 430px;

                    top: -220px;
                    right: -160px;

                    background: rgba(0, 132, 61, 0.055);
                }

                .circle-two {
                    width: 320px;
                    height: 320px;

                    bottom: -170px;
                    left: -120px;

                    background: rgba(244, 180, 0, 0.075);
                }

                .courses-background-grid {
                    position: absolute;
                    inset: 0;

                    opacity: 0.22;
                    pointer-events: none;

                    background-image:
                        linear-gradient(
                            rgba(0, 132, 61, 0.035) 1px,
                            transparent 1px
                        ),
                        linear-gradient(
                            90deg,
                            rgba(0, 132, 61, 0.035) 1px,
                            transparent 1px
                        );

                    background-size: 45px 45px;
                }

                /* =========================
                   HEADER
                ========================= */

                .courses-header {
                    max-width: 850px;
                    margin: 0 auto 65px;

                    text-align: center;
                }

                .courses-eyebrow {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 13px;

                    margin-bottom: 18px;

                    color: #00843d;

                    font-size: 12px;
                    font-weight: 800;
                    letter-spacing: 2.5px;
                }

                .eyebrow-line {
                    width: 35px;
                    height: 2px;

                    background: #f4b400;
                }

                .courses-header h1 {
                    margin: 0;

                    color: #111111;

                    font-size: clamp(
                        38px,
                        5vw,
                        64px
                    );

                    line-height: 1.05;
                    font-weight: 850;
                    letter-spacing: -2px;
                }

                .courses-header h1 span {
                    display: block;
                    color: #00843d;
                }

                .courses-header p {
                    max-width: 760px;

                    margin: 25px auto 0;

                    color: #626262;

                    font-size: 15px;
                    line-height: 1.9;
                }

                .header-accent {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;

                    margin-top: 25px;
                }

                .header-accent span {
                    height: 5px;
                    border-radius: 20px;
                }

                .header-accent span:nth-child(1) {
                    width: 38px;
                    background: #00843d;
                }

                .header-accent span:nth-child(2) {
                    width: 60px;
                    background: #f4b400;
                }

                .header-accent span:nth-child(3) {
                    width: 18px;
                    background: #111111;
                }

                /* =========================
                   GRID
                ========================= */

                .courses-grid {
                    display: grid;

                    grid-template-columns:
                        repeat(3, minmax(0, 1fr));

                    gap: 32px;
                }

                /* =========================
                   CARD
                ========================= */

                .course-card {
                    position: relative;

                    width: 100%;

                    background: #ffffff;

                    border-radius: 20px;

                    border: 1px solid
                        rgba(0, 0, 0, 0.07);

                    box-shadow:
                        0 12px 35px
                        rgba(0, 0, 0, 0.075);

                    overflow: visible;

                    opacity: 0;

                    transform:
                        translateY(45px);

                    transition:
                        opacity 0.65s ease,
                        transform 0.65s ease,
                        box-shadow 0.35s ease;
                }

                .course-card.visible {
                    opacity: 1;

                    transform:
                        translateY(0);
                }

                .course-card:hover {
                    transform:
                        translateY(-10px);

                    box-shadow:
                        0 25px 55px
                        rgba(0, 0, 0, 0.14);
                }

                /* =========================
                   IMAGE
                ========================= */

                .course-image-wrapper {
                    position: relative;

                    width: 100%;
                    height: 235px;

                    overflow: hidden;

                    border-radius:
                        20px 20px 0 0;

                    background: #111111;
                }

                .course-image-wrapper img {
                    width: 100%;
                    height: 100%;

                    display: block;

                    object-fit: cover;

                    transition:
                        transform 0.65s
                        cubic-bezier(
                            0.22,
                            1,
                            0.36,
                            1
                        );
                }

                .course-card:hover
                .course-image-wrapper img {
                    transform: scale(1.09);
                }

                .course-image-overlay {
                    position: absolute;

                    inset: 0;

                    background:
                        linear-gradient(
                            to bottom,
                            rgba(0, 0, 0, 0.05),
                            rgba(0, 0, 0, 0.65)
                        );

                    pointer-events: none;
                }

                .course-image-top {
                    position: absolute;

                    top: 18px;
                    left: 18px;
                    right: 18px;

                    z-index: 5;

                    display: flex;

                    align-items: center;
                    justify-content:
                        space-between;

                    gap: 10px;
                }

                .course-number {
                    display: inline-flex;

                    align-items: center;
                    justify-content: center;

                    padding:
                        7px 12px;

                    border-radius: 30px;

                    background: #f4b400;

                    color: #111111;

                    font-size: 10px;
                    font-weight: 900;

                    letter-spacing: 1px;
                }

                .course-category {
                    display: inline-flex;

                    align-items: center;
                    justify-content: center;

                    padding:
                        7px 12px;

                    border-radius: 30px;

                    background:
                        rgba(
                            0,
                            0,
                            0,
                            0.72
                        );

                    color: #ffffff;

                    font-size: 10px;
                    font-weight: 700;

                    letter-spacing: 0.7px;
                }

                /* =========================
                   FLOATING ICON
                   IMPORTANT FIX
                ========================= */

                .course-icon {
                    position: absolute;

                    /*
                       The image ends at 235px.
                       The icon begins at 198px,
                       therefore it occupies the area
                       from 198px to 266px.

                       This makes it visibly float
                       across the boundary while its
                       center remains above the white
                       description area.
                    */
                    top: 198px;
                    left: 27px;

                    width: 70px;
                    height: 70px;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    border-radius: 18px;

                    background: #00843d;

                    color: #ffffff;

                    border:
                        5px solid #ffffff;

                    box-shadow:
                        0 10px 28px
                        rgba(0, 0, 0, 0.24),
                        0 5px 15px
                        rgba(
                            0,
                            132,
                            61,
                            0.22
                        );

                    font-size: 28px;

                    z-index: 100;

                    transition:
                        transform 0.35s ease,
                        background 0.35s ease,
                        color 0.35s ease,
                        box-shadow 0.35s ease;
                }

                .course-card:hover
                .course-icon {
                    transform:
                        translateY(-7px)
                        rotate(-5deg);

                    background: #f4b400;

                    color: #111111;

                    box-shadow:
                        0 15px 32px
                        rgba(0, 0, 0, 0.25);
                }

                /* =========================
                   CONTENT
                ========================= */

                .course-content {
                    position: relative;

                    z-index: 20;

                    padding:
                        55px 28px 28px;

                    background: #ffffff;

                    border-radius:
                        0 0 20px 20px;
                }

                .course-title {
                    margin:
                        0 0 14px;

                    color: #111111;

                    font-size: 23px;

                    line-height: 1.2;

                    font-weight: 850;

                    letter-spacing:
                        -0.4px;

                    transition:
                        color 0.3s ease;
                }

                .course-card:hover
                .course-title {
                    color: #00843d;
                }

                /* =========================
                   META
                ========================= */

                .course-meta {
                    display: flex;

                    flex-wrap: wrap;

                    gap: 8px;

                    margin-bottom: 18px;
                }

                .course-level,
                .course-duration {
                    display: inline-flex;

                    align-items: center;

                    gap: 6px;

                    padding:
                        7px 10px;

                    border-radius:
                        20px;

                    font-size: 10px;

                    font-weight: 750;
                }

                .course-level {
                    background:
                        rgba(
                            0,
                            132,
                            61,
                            0.09
                        );

                    color: #00843d;
                }

                .course-duration {
                    background:
                        rgba(
                            244,
                            180,
                            0,
                            0.15
                        );

                    color: #866300;
                }

                /* =========================
                   DESCRIPTION
                ========================= */

                .course-description {
                    margin:
                        0 0 22px;

                    color: #646464;

                    font-size: 13.5px;

                    line-height: 1.8;
                }

                /* =========================
                   SKILLS TITLE
                ========================= */

                .skills-heading {
                    display: flex;

                    align-items: center;

                    gap: 9px;

                    margin-bottom: 13px;
                }

                .skills-heading span {
                    width: 23px;
                    height: 3px;

                    border-radius: 10px;

                    background: #f4b400;
                }

                .skills-heading strong {
                    color: #111111;

                    font-size: 10px;

                    font-weight: 850;

                    letter-spacing:
                        1.5px;
                }

                /* =========================
                   SKILLS
                ========================= */

                .course-skills {
                    display: grid;

                    grid-template-columns:
                        repeat(2, minmax(0, 1fr));

                    gap: 10px;

                    margin-bottom: 24px;
                }

                .course-skill {
                    display: flex;

                    align-items:
                        flex-start;

                    gap: 7px;

                    color: #3d3d3d;

                    font-size: 11.5px;

                    line-height: 1.45;
                }

                .course-skill svg {
                    flex-shrink: 0;

                    margin-top: 2px;

                    color: #00843d;

                    font-size: 12px;
                }

                /* =========================
                   FOOTER
                ========================= */

                .course-footer {
                    display: flex;

                    align-items: center;

                    justify-content:
                        space-between;

                    padding-top: 18px;

                    border-top:
                        1px solid
                        #eeeeee;
                }

                .course-footer-label {
                    color: #00843d;

                    font-size: 10px;

                    font-weight: 850;

                    letter-spacing:
                        1px;
                }

                .course-footer-arrow {
                    width: 36px;
                    height: 36px;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    border-radius: 50%;

                    background: #f4b400;

                    color: #111111;

                    font-size: 13px;

                    transition:
                        transform 0.3s ease,
                        background 0.3s ease,
                        color 0.3s ease;
                }

                .course-card:hover
                .course-footer-arrow {
                    transform:
                        translateX(6px);

                    background: #00843d;

                    color: #ffffff;
                }

                /* =========================
                   CALLOUT
                ========================= */

                .courses-callout {
                    position: relative;

                    display: flex;

                    align-items: center;

                    justify-content:
                        space-between;

                    gap: 30px;

                    margin-top: 65px;

                    padding:
                        30px 35px;

                    border-radius: 20px;

                    background: #111111;

                    box-shadow:
                        0 18px 45px
                        rgba(
                            0,
                            0,
                            0,
                            0.15
                        );

                    overflow: hidden;
                }

                .courses-callout::after {
                    content: "";

                    position: absolute;

                    width: 240px;
                    height: 240px;

                    right: -100px;
                    top: -110px;

                    border-radius: 50%;

                    background:
                        rgba(
                            0,
                            132,
                            61,
                            0.2
                        );
                }

                .callout-left {
                    position: relative;

                    z-index: 2;

                    display: flex;

                    align-items: center;

                    gap: 20px;
                }

                .callout-symbol {
                    width: 60px;
                    height: 60px;

                    flex-shrink: 0;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    border-radius: 16px;

                    background: #f4b400;

                    color: #111111;

                    font-size: 24px;
                }

                .callout-small {
                    margin-bottom: 5px;

                    color: #f4b400;

                    font-size: 9px;

                    font-weight: 850;

                    letter-spacing:
                        1.8px;
                }

                .courses-callout h3 {
                    margin: 0;

                    color: #ffffff;

                    font-size: 24px;

                    line-height: 1.25;

                    font-weight: 800;
                }

                .courses-callout p {
                    max-width: 750px;

                    margin:
                        7px 0 0;

                    color: #bdbdbd;

                    font-size: 12px;

                    line-height: 1.6;
                }

                .callout-arrow {
                    position: relative;

                    z-index: 5;

                    width: 55px;
                    height: 55px;

                    flex-shrink: 0;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    border-radius: 50%;

                    background: #00843d;

                    color: #ffffff;

                    font-size: 18px;

                    transition:
                        transform 0.3s ease,
                        background 0.3s ease;
                }

                .courses-callout:hover
                .callout-arrow {
                    transform:
                        translateX(6px);

                    background: #f4b400;

                    color: #111111;
                }

                /* =========================
                   TABLET
                ========================= */

                @media (max-width: 1050px) {
                    .vocational-courses-section {
                        padding:
                            85px 22px 90px;
                    }

                    .courses-grid {
                        grid-template-columns:
                            repeat(
                                2,
                                minmax(0, 1fr)
                            );

                        gap: 27px;
                    }

                    .course-image-wrapper {
                        height: 225px;
                    }

                    .course-icon {
                        top: 188px;
                    }

                    .courses-callout h3 {
                        font-size: 21px;
                    }
                }

                /* =========================
                   MOBILE
                ========================= */

                @media (max-width: 700px) {
                    .vocational-courses-section {
                        padding:
                            70px 16px 75px;
                    }

                    .courses-header {
                        margin-bottom: 45px;
                    }

                    .courses-eyebrow {
                        font-size: 9px;

                        letter-spacing:
                            1.7px;
                    }

                    .eyebrow-line {
                        width: 22px;
                    }

                    .courses-header h1 {
                        font-size: 39px;

                        letter-spacing:
                            -1.5px;
                    }

                    .courses-header p {
                        font-size: 13px;

                        line-height: 1.75;
                    }

                    .courses-grid {
                        grid-template-columns:
                            1fr;

                        gap: 28px;
                    }

                    .course-image-wrapper {
                        height: 225px;
                    }

                    /*
                       On mobile the icon remains
                       above the white description
                       area with enough separation.
                    */
                    .course-icon {
                        top: 188px;
                        left: 22px;

                        width: 67px;
                        height: 67px;

                        border-width: 5px;

                        border-radius: 17px;

                        font-size: 26px;
                    }

                    .course-content {
                        padding:
                            53px 22px 24px;
                    }

                    .course-title {
                        font-size: 21px;
                    }

                    .course-description {
                        font-size: 13px;
                    }

                    .course-skills {
                        gap: 9px;
                    }

                    .course-skill {
                        font-size: 11px;
                    }

                    .courses-callout {
                        align-items:
                            flex-start;

                        padding:
                            25px 22px;

                        margin-top: 45px;
                    }

                    .callout-left {
                        align-items:
                            flex-start;

                        gap: 14px;
                    }

                    .callout-symbol {
                        width: 48px;
                        height: 48px;

                        border-radius: 13px;

                        font-size: 19px;
                    }

                    .courses-callout h3 {
                        font-size: 18px;
                    }

                    .courses-callout p {
                        font-size: 11px;
                    }

                    .callout-arrow {
                        display: none;
                    }
                }

                @media (max-width: 420px) {
                    .vocational-courses-section {
                        padding-left: 12px;
                        padding-right: 12px;
                    }

                    .course-image-wrapper {
                        height: 210px;
                    }

                    .course-icon {
                        top: 173px;
                        left: 19px;

                        width: 64px;
                        height: 64px;
                    }

                    .course-content {
                        padding:
                            50px 19px 22px;
                    }

                    .course-skills {
                        grid-template-columns:
                            1fr;
                    }

                    .course-image-top {
                        left: 13px;
                        right: 13px;
                    }

                    .course-number,
                    .course-category {
                        padding:
                            6px 9px;

                        font-size: 8px;
                    }
                }
            `}</style>
        </>
    );
};

export default CoursesPage;